module.exports = __webpack_public_path__ + "static/img/37.43c75cb8.jpg";